module.exports = __webpack_public_path__ + "666debb82039db111d77e7e0c98beeb3.ttf";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Medium.ttf
// module id = 647
// module chunks = 0